// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__133Vl","upload":"Small_upload__2lW_y","imageWrap":"Small_imageWrap__2QNX6","removeBtn":"Small_removeBtn__Z_-hi"};